module.exports = __webpack_public_path__ + "img/rise-and-shine.97f89e9d.svg";